import React from 'react';
import { Fragment } from 'react';
import Footer from '../../../components/footer';
import Head from '../../../components/head';
import Header from '../../../components/headerlogged';
import Componentes from '../../../components/user/componentes/cadastrar';


function CadComponentesScreen () {
    return (
        <Fragment>
            <Head titulo="Cadastro de Componentes | Departamento de TI" />
            <Header />
            <Componentes />
            <Footer />
        </Fragment>
    );
}

export default CadComponentesScreen;